var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTomato(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8248,
    cy: 37.5975,
    rx: 25.0149,
    ry: 22.3817,
    fill: "#EA5A47",
    stroke: "#EA5A47",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D22F27",
    stroke: "#D22F27",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8,
    d: "M60.5279,37.5975 c0,12.3648-10.89,22.3817-24.703,22.3817c17.4001-4.1037,31.9603-32.9321,0-44.7634c5.0852,0,9.8164,1.3576,13.7651,3.6901 C56.3674,22.9092,60.5279,29.7846,60.5279,37.5975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CC33",
    stroke: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M46.3245,15.8489 c-0.384,1.3824-0.9937,3.0311-2.4357,4.235C38,25,30.2513,23.2876,26.8173,20.0838c-1.3604-1.2836-2.0407-2.8525-2.4246-4.235 c-0.6364-2.2821-0.3621-4.1691-0.3621-4.1691s2.2821-0.3291,4.8384,0.5815c0.8668,0.3072,1.7664,0.757,2.6222,1.4044 c0.4827-3.3682,2.7319-5.6174,3.5547-6.3415l0.3072-0.2523l0.3072,0.2523c0.8229,0.7242,3.0721,2.9733,3.5548,6.3415 c0.8557-0.6473,1.7554-1.0971,2.6221-1.4044c2.5564-0.9106,4.8384-0.5815,4.8384-0.5815S46.9609,13.5668,46.3245,15.8489z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M50.3073,19.3462c6.3743,4.0565,10.5324,10.7195,10.5324,18.2513c0,12.3611-11.1995,22.3817-25.0149,22.3817 S10.81,49.9586,10.81,37.5975c0-7.3745,3.9861-13.9159,10.1357-17.9936"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M46.3245,15.8489 c-0.384,1.3824-0.9937,3.0311-2.4357,4.235C38,25,30.2513,23.2876,26.8173,20.0838c-1.3604-1.2836-2.0407-2.8525-2.4246-4.235 c-0.6364-2.2821-0.3621-4.1691-0.3621-4.1691s2.2821-0.3291,4.8384,0.5815c0.8668,0.3072,1.7664,0.757,2.6222,1.4044 c0.4827-3.3682,2.7319-5.6174,3.5547-6.3415l0.3072-0.2523l0.3072,0.2523c0.8229,0.7242,3.0721,2.9733,3.5548,6.3415 c0.8557-0.6473,1.7554-1.0971,2.6221-1.4044c2.5564-0.9106,4.8384-0.5815,4.8384-0.5815S46.9609,13.5668,46.3245,15.8489z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomato);
export default __webpack_public_path__ + "static/media/tomato.426cbf58da3ea8b9816c268a03e459d9.svg";
export { ForwardRef as ReactComponent };